<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="date" label="Tanggal Aktual">
                    <v-date-picker
                      mode="range"
                      id="date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Aktual', required: '', readonly: ''}"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="filtering" label="Tipe Download">
                    <model-select
                      id="filtering"
                      :options="filtering"
                      v-model="filValue"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export SPKB Piutang</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "spkb_piutang",
  components: {
    loading,
    ModelSelect
  },
  data() {
    return {
      filtering: [
            {value: 'default', text: 'Default'},
            {value: 'accurate', text: 'For Accurate Only'}
        ],
      month: [
        { value: "01", text: "January" },
        { value: "02", text: "February" },
        { value: "03", text: "March" },
        { value: "04", text: "April" },
        { value: "05", text: "May" },
        { value: "06", text: "June" },
        { value: "07", text: "July" },
        { value: "08", text: "August" },
        { value: "09", text: "September" },
        { value: "10", text: "October" },
        { value: "11", text: "November" },
        { value: "12", text: "December" }
      ],
      year: [{ value: "2019", text: "2019" }, { value: "2020", text: "2020" }],
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      loading: false,
      myDate: null,
      filValue: 'default'
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if (this.myDate === null) {
          alert("Tanggal Harus di pilih");
        } else {
          let start = moment(this.myDate.start).format("YYYY-MM-DD");
          let end = moment(this.myDate.end).format("YYYY-MM-DD");
          let flg = '';
          this.loading = true;

          if(this.filValue !== 'default') {
            flg = '-for-accurate';
          }

          this.axios({
            url: "web/export/data-spkb-piutang"+flg+"/" + start + "/" + end + "/2/",
            method: "GET",
            responseType: "blob"
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "spkb_piutang.xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
          //window.location.href = axios.defaults.baseURL+'web/export/data-attendance/'+this.currentMonth+'/'+this.currentYear+'/';
          //window.location.href = axios.defaults.baseURL+'web/export/data-order-history/'+start+'/'+end+'/';
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
